export {
    default,
} from './AutoComplete';

/*
export type {
    AutoCompleteProps,
} from './AutoComplete';
*/